import { updateField } from "vuex-map-fields";
import { initialSurveyState } from "./state";
export const mutations = {
  SET_FILTER_TOTAL(state, total) {
    state.pagination.total = total;
    state.pagination.last_page = Math.ceil(total / state.pagination.per_page);
  },
  SET_CURRENT_PAGE(state, page) {
    state.pagination.current_page = page;
  },
  SET_CURRENT_VERSION(state, payload) {
    state.current_version = payload;
  },
  SET_SURVEY_ENTRIES(state, payload) {
    state.surveySubmissions = payload;
  },
  setSurveys(state, documents) {
    state.surveys = documents;
  },

  setCurrentSurvey(state, form) {
    state.currentSurvey = { ...form };
  },

  setSortBy(state, { direction, field }) {
    // set direction to 'asc' if not set
    const newDirection = direction || "asc";

    state.sortBy.direction = newDirection;
    state.sortBy.field = field;
  },

  setSearchQuery(state, searchQuery) {
    state.filters.searchQuery = searchQuery;
  },

  setFilterCategories(state, categories) {
    state.filters.categories = categories;
  },

  reset(state) {
		// doing this suggests the initial state is being mutated somewhere
		const originalState = JSON.parse(JSON.stringify(initialSurveyState.currentSurvey));
    state.currentSurvey = originalState;
  },

  clearFilters(state) {
    state.filters.categories = [];
    state.filters.searchQuery = "";
  },

  setFavourites(state, favourites) {
    state.favourites = favourites;
  },

  setTabFilter(state, tabFilter) {
    state.tabFilter = tabFilter;
  },

  addSurveyVersions(state, versionData) {
    state.surveyVersions = versionData.versions;
  },

  SET_USER_FILTER(state, val) {
    state.user_filter = val;
  },

  updateField,
};
